import colors from '../../colors.json';

export const colorStops = [
  [1/9, colors['heat']['sellers-900']],
  [2/9, colors['heat']['sellers-900']],
  [3/9, colors['heat']['sellers-900']],
  [4/9, colors['text']['400']],
  [5/9, colors['text']['400']],
  [6/9, colors['text']['400']],
  [7/9, colors['heat']['buyers-900']],
  [8/9, colors['heat']['buyers-900']],
  [9/9, colors['heat']['buyers-900']],
];

const IDLE = 1.2;

const between = (low, high) => low + Math.random() * (high - low);
const anyOf = (low, high) => low + Math.floor(Math.random() * (high - low + 1));

// Before the market's figure arrives the needle idles low with no number under it.
export function idlingNeedle(series) {
  series.detail.show = false;
  series.data[0].value = IDLE;
}

// The needle of an engine being revved, one move at a time: it flutters at idle, snaps up,
// trembles at the top, then drops back quick and settles. A move's `after` is when the next
// one starts, which can cut a drop short for a second blip.
export function* revving() {
  while (true) {
    yield* flutter(IDLE, anyOf(3, 7), 0.2);
    if (Math.random() < 0.4) yield* rev(between(3.5, 6), 300);
    yield* rev(between(5, 8.4), 750);
  }
}

function* rev(peak, letOff) {
  yield { value: peak, duration: 240, easing: 'cubicOut', after: 240 };
  yield* flutter(peak, anyOf(1, 3), 0.15);
  yield { value: IDLE, duration: 750, easing: 'cubicOut', after: letOff };
}

function* flutter(reading, count, spread) {
  for (let move = 0; move < count; move++) {
    yield { value: reading + between(-spread, spread), duration: 100, easing: 'linear', after: 100 };
  }
}

export function axisLabelFormatter(value) {
  if (value === 0.9) return "Seller's";
  if (value === 4.5) return 'Balanced';
  if (value === 8.1) return "Buyer's";
  return '';
}
